import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@pipecat-ai/voice-ui-kit/styles.scoped.css'
import './index.css'
import './i18n'
import App from './App'
import { initSentry } from './observability/sentry'

initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
